<template>
  <div class="personal-page page-moblie" :style="homeStyle">
    <div class="page-header">
      <div class="company-head-img" :style="headImgStyle"></div>
      <div v-if="showCompanyLogo" class="company-logo" :style="logoStyle"></div>
    </div>
    <div class="page-body">
      <Menu class="page-menu" :personalInfo="personalInfo" :companyInfo="companyInfo" :hideCompanyMenu="!customPageInfo.has_custom_mobile_landing_page"></Menu>
      <div class="page-content">
        <router-view
          :personalInfo="personalInfo"
          :companyHasReferralPremium="companyHasReferralPremium"
          :companyHasSoftUserPremium="companyHasSoftUserPremium"
          :companyHiddenRewards="companyHiddenRewards"
          :companyHiddenReferralRewards="companyHiddenReferralRewards"
          :companyHiddenReferralLeaderBoard="companyHiddenReferralLeaderBoard"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Menu from './menu'
import { getFilePath } from '@/utils/qiniu'

export default {
  components: {
    Menu
  },
  props: {
    personalInfo: {
      required: true
    }
  },
  data () {
    return {
      companyInfo: {
        root_company: { id: null },
        premium: {}
      },
      customPageInfo: { default_header_image: '', header_image: '' },
      defaultColor: '#0096cc'
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    },
    rootCompanyId () {
      return this.companyInfo.root_company.id
    },
    companyHasReferralPremium () {
      return this.companyId ? this.companyInfo.premium.referral : true
    },
    companyHasSoftUserPremium () {
      return this.companyId ? this.companyInfo.premium.soft_user : true
    },
    companyHiddenRewards () {
      return this.companyId ? this.companyInfo.premium.hidden_rewards : false
    },
    companyHiddenReferralRewards () {
      const companyId = this.companyInfo?.root_company.id || this.personalInfo.employee?.company.root_company.id
      return companyId === 12600 || companyId === 12699 || companyId === 13509
    },
    companyHiddenReferralLeaderBoard () {
      const companyId = this.companyInfo?.root_company.id || this.personalInfo.employee?.company.root_company.id
      return companyId === 13509
    },
    homeStyle () {
      return {
        '--custom-color': this.companyInfo?.custom_color || this.defaultColor
      }
    },
    showCompanyLogo () {
      return Boolean(this.companyId)
    },
    headImgStyle () {
      const headerImgSrc = this.showCompanyLogo && this.customPageInfo.has_custom_mobile_landing_page ? getFilePath(this.customPageInfo.header_image) : this.customPageInfo.default_header_image
      return {
        backgroundImage: headerImgSrc ? `url(${headerImgSrc})` : null
      }
    },
    logoStyle () {
      return {
        backgroundImage: this.companyInfo.logo ? `url(${this.$DjangoBaseUrl(this.companyInfo.logo)})` : null
      }
    }
  },
  created () {
    this.refreshCompanyInfo()
  },
  methods: {
    ...mapActions('company', ['getCompanyBaseInfo', 'getCustomJobListPageInfo']),
    async refreshCompanyInfo () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const promiseList = []
        if (this.companyId) {
          const getInfoParams = { id: this.companyId, params: { simple_info: 1 } }
          const getInfoPromise = this.getCompanyBaseInfo(getInfoParams).then(resp => {
            this.companyInfo = resp
          })
          promiseList.push(getInfoPromise)
        }
        const getCustomPageInfo = this.getCustomJobListPageInfo({ company_id: this.companyId || 'default' }).then(resp => {
          this.customPageInfo = resp
        })
        promiseList.push(getCustomPageInfo)
        await Promise.all(promiseList)
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    changeTab (path) {
      this.$router.push(this.tabPath[path])
    }
  },
  watch: {
    companyId () {
      this.refreshCompanyInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-page {
  display: flex;
  height: 100vh;
  height: 100dvh;
  flex-direction: column;
  font-size: 12px;
  color: #333333;
  overflow: auto;

  .page-header {
    // height: 180px;
    position: relative;

    .company-head-img {
      height: 180px;
      overflow: hidden;
      background-size: cover;
      background-position: center;
      background-color: #f7f7f7;
    }

    .company-logo {
      width: 70px;
      height: 70px;
      margin: -35px auto;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-color: #f7f7f7;
    }
  }

  .page-body {
    flex: 1;
    background: #e5e5e5;

    .page-menu {
      height: 60px;
      position: relative;

      ::v-deep {
        .menu-handler {
          position: absolute;
          top: 15px;
          left: 10px;
        }
      }
    }
  }
}
</style>
